<h2 mat-dialog-title>
  {{title}}
</h2>

<mat-dialog-content style="padding: 10px;">
  @if (!isSaving) {
    @if (success) {
      <div>{{successMessage}}</div>
    } @else {
      <div>{{errorMessage}}</div>
      <br>
        <br>
          <div>{{errors}}</div>
        }
      } @else {
        <busy-indicator></busy-indicator>
      }
    </mat-dialog-content>

    <mat-dialog-actions>
      @if (!isSaving) {
        <button mat-button color="primary" (click)="close()" telemetry="Submission-SaveDialogOK">
          OK
        </button>
      }
    </mat-dialog-actions>


